<template>
  <div class="frontCommon">
    <commonBanner :bgImg="bgImg" :search="false"></commonBanner>
    <div class="center-setting">
      <MultipleFilter
        class="multiple-wrap mt33"
        :options="filterOptions"
        @chacked="mutipleChacked"
        @closeTag="mutipleChacked"
      ></MultipleFilter>
      <SimpleFilter
        :keywords="keywords"
        @search="handleSearch"
        @issueTime="handleIssue"
        @viewCount="handleView"
        @handleDefault="handleDefault"
        @searchValueChange="searchValueChange"
      ></SimpleFilter>
      <VideoList
        :resultList="resultList"
        :loading="loading"
        :isEmpty="isEmpty"
      ></VideoList>
      <Pagination
        ref="pagination"
        :total="total"
        @change="handlerPaginationChange"
      ></Pagination>
    </div>
  </div>
</template>

<script>
import commonBanner from '@/components/common/banner'
import VideoList from './component/videoList.vue'
import { filterOptions } from './config/config.js';
import MultipleFilter from '@/components/MultipleFilter';
import SimpleFilter from '@/components/common/SimpleFilter'
import Pagination from '@/views/IndustryInformation/pages/components/pagination'
import { getVideoList } from '@/api/MTrainVideo'
import { cloneDeep } from 'lodash'

export default {
  data() {
    return {
      bgImg: require('@/assets/images/知产培训banner.png'),
      filterOptions: [], // 多选过滤
      keywords: '', // 检索关键词
      loading: false,
      isEmpty: false,
      resultList: [],
      total: 0, // 数据的总数
      url: '', // 播放视频的路径
      searchParams: {
        videoType: '',
      },
      pageParams: {
        pageSize: 10,
        pageNum: 1,
      },
      datas: '', //多选按钮值
      searchVal: ''
    }
  },
  components: {
    Pagination,
    VideoList,
    MultipleFilter,
    SimpleFilter,
    commonBanner
  },
  watch: {
    $route: {
      handler(nVal) {
        const { keywords } = nVal.query
        if (keywords && keywords !== '') {  //处理首页搜索
          this.keywords = keywords
          this.handleSearch(keywords)
        } else {
          this.loadData();
        }
      },
      immediate: true,
    },
  },
  created() {
    this.filterOptions = cloneDeep(filterOptions)
  },
  methods: {
    searchValueChange(value) {
      this.searchVal = value
    },
    handlerInitPicture(rows) {
      rows.forEach((item) => {
        if (!item.fileVo) {
          item.fileVo = { filePath: '/static/wuxi/video_empty_bg.png' }
        }
      })
    },
    // 简单筛选恢复默认
    handleDefault() {
      delete this.searchParams.params
      this.loadData()
    },
    // 浏览量筛选
    handleView(e) {
      this.searchParams = { ...this.searchParams, params: { sort: e, sortType: '2' } }
      this.loadData()
    },
    // 发布时间筛选
    handleIssue(e) {
      this.searchParams = { ...this.searchParams, params: { sort: e, sortType: '1' } }
      this.loadData()
    },
    //simple
    handleSearch(e) {
      this.searchVal = e
      const params = { name: e, ...this.datas } //不记录排序
      this.searchParams = params
      // 更新到vuex中
      // this.updateTabValue({ key: 'result', value: e })
      this.loadData()
    },
    // 加载数据
    async loadData() {
      try {
        this.loading = true;
        const { rows, total } = await getVideoList(this.pageParams, this.searchParams);
        this.handlerInitPicture(rows) // 没有图片使用默认的系统图片
        this.total = total
        this.isEmpty = rows.length === 0;
        this.resultList = rows;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    // 分页器参数变化，带动列表的数据变化
    handlerPaginationChange() {
      const paginationRef = this.$refs.pagination
      this.pageParams = {
        pageNum: paginationRef.currentPage || 1,
        pageSize: paginationRef.pageSize || 10,
      }
      this.loadData()
    },
    // 点击选择条件进行过滤
    mutipleChacked(params) {
      const datas = {};
      Object.keys(params).forEach((key) => {
        const data = params[key];
        if (Object.keys(data).length === 0) return;
        const {
          instance: { prop },
          value,
        } = data;
        datas[prop] = value;
      });
      this.datas = datas; //记录多选值
      this.searchParams = { ...datas, name: this.searchVal };
      this.loadData();
    },
  },
}
</script>
